import { Form } from '@epages/react-components'
import type { ReactElement } from 'react'
import Immutable from 'immutable'

import { useTranslate } from '../../../../../utils/translate'
import Button from '../../../../formComponents/Button'
import ButtonRow from '../../../../formComponents/ButtonRow'
import CustomSelect from '../components/CustomSelect'
import FormGroup from '../../../../formComponents/FormGroup'
import FormValue from '../../../../formComponents/FormValue'

type DividerValue = 'solid' | 'dashed' | 'dotted'
type DividerOption = {
  value: DividerValue
  label: string
}

export default function DividerSettings({
  data,
  onDataChange,
  onCancel,
  onSave,
  renderLayout,
}: WorkspacePluginSettingsProps): ReactElement {
  const t = useTranslate('interface', 'components.dividerElementComponent.settingsModal')

  const title = t('title.onEdit')

  const options: Immutable.List<DividerOption> = Immutable.List([
    { value: 'solid', label: t('selectBox.option.solid') },
    { value: 'dashed', label: t('selectBox.option.dashed') },
    { value: 'dotted', label: t('selectBox.option.dotted') },
  ])

  const body = (
    <FormGroup name="dividerType" tagName="label" label={t('selectBox.label')}>
      <FormValue>
        {(value: DividerValue, setValue: (value: DividerValue) => void) => (
          <CustomSelect
            className="ep-divider-settings-select"
            options={options}
            renderOption={(option: DividerOption) => (
              <span className="ep-custom-divider">
                <label className="visually-hidden">{option.label}</label>
                <hr style={{ borderStyle: option.value }} />
              </span>
            )}
            selectedIndex={options.findIndex((option: DividerOption) => option.value === value)}
            onChange={(index: number) => setValue(options.get(index).value)}
          />
        )}
      </FormValue>
    </FormGroup>
  )

  const footer = (
    <ButtonRow>
      <Button variant="cancel" type="button" onClick={onCancel}>
        {t('cancelButton.label')}
      </Button>
      <Button>{t('saveButton.label')}</Button>
    </ButtonRow>
  )

  return (
    <Form name="pluginDividerSettings" value={data} onChange={onDataChange} onSubmit={onSave}>
      {renderLayout({ title, body, footer })}
    </Form>
  )
}
